import React from 'react';
import reactStringReplace from 'react-string-replace';
import { escapeRegExp, size } from 'lodash';
import config from '../config';

exports.getFirstRelativeParent = function (element) {
  return $(element).parents().filter(function () {
    var position = $(this).css('position');
    return (position == 'relative') || (position == 'absolute');
  }).get(0);
};


var createSearchRegExpFromString = function (string, replaceRegExp, replaceChars) {
  replaceRegExp = replaceRegExp || new RegExp("\\s", 'g');
  replaceChars = replaceChars || "|";
  string = escapeRegExp(string);
  string = string.replace(replaceRegExp, replaceChars);
  return new RegExp("(" + string + ")", 'ig');
};

exports.highlightText = function (text, searchRegexp, colorClassName, color) {
  if (!searchRegexp) return text;

  var style = {}, className = colorClassName ? colorClassName : "";

  if (color) {
    style[backgroundColor] = color;
  } else if (!className) {
    className = config.searchHighlightColorClass;
  }

  return reactStringReplace(text, createSearchRegExpFromString(searchRegexp),
    (item, index) => {
      return (
        <span key={index} style={style} className={className}>{item}</span>);
    }
  );
};

exports.matchString = function (targetString, searchString) {
  if (!targetString || !searchString) return false;

  var searchArray = searchString.split(" ").map(
    (item) => ( item ? "(^|\\s)" + escapeRegExp(item) : null )
  );

  return new RegExp("(" + searchArray
      .filter((item) => (!!item))
      .join("(.+?)") + ")", 'i')
    .test(targetString);

};

exports.getTextWithEllipsis = function (text, numberOfChars) {
  if (size(text) <= numberOfChars) {
    return text;
  }

  return text.substring(0, numberOfChars) + '...';
}
